export default "__VITE_ASSET__DLtm3SGj__"